import { createSelector } from '@ngrx/store';
import { CoreState, getCoreState } from '../../../store/reducers';
import { TenantState } from '../reducers/tenant.reducer';

const getTenantState = createSelector(
  getCoreState,
  (state: CoreState) => state.tenant,
);

const getBootstrapLoading = (state: TenantState) => state.bootstrapLoading;
const getBootstrapLocales = (state: TenantState) => state.locales;
const getBootstrapCurrencies = (state: TenantState) => state.currencies;
const getBootstrapLoyaltyCurrencies = (state: TenantState) =>
  state.loyaltyCurrencies;
const getBootstrapLoyaltyPrograms = (state: TenantState) =>
  state.loyaltyPrograms;
const getBootstrapTimezoneOffsetInMinutes = (state: TenantState) =>
  state.timeZoneOffsetInMinutes;
const getBootstrapTimezoneOffset = (state: TenantState) => state.timeZoneOffset;

const getBootstrapRoundingPreference = (state: TenantState) =>
  state.roundingPreferences;

const getBoostrapPaymentProcessingFee = (state: TenantState) =>
  state.paymentProcessingFee;

const getBoostrapFeatureFlags = (state: TenantState) => state.featureFlags;

const getBootstrapPageLoadingState = (state: TenantState) =>
  state.pageLoadingState;

export const getTenantBootstrapLoading = createSelector(
  getTenantState,
  getBootstrapLoading,
);

export const getTenantBootstrapCurrencies = createSelector(
  getTenantState,
  getBootstrapCurrencies,
);

export const getTenantBootstrapLocales = createSelector(
  getTenantState,
  getBootstrapLocales,
);

export const getTenantBootstrapLoyaltyCurrencies = createSelector(
  getTenantState,
  getBootstrapLoyaltyCurrencies,
);

export const getTenantBootstrapLoyaltyPrograms = createSelector(
  getTenantState,
  getBootstrapLoyaltyPrograms,
);

export const getTenantBootstrapTimeZoneOffsetInMinutes = createSelector(
  getTenantState,
  getBootstrapTimezoneOffsetInMinutes,
);

export const getTenantBootstrapTimeZoneOffset = createSelector(
  getTenantState,
  getBootstrapTimezoneOffset,
);

export const getTenantBootstrapRoundingPreference = createSelector(
  getTenantState,
  getBootstrapRoundingPreference,
);

export const getTenantBootstrapPaymentProcessingFee = createSelector(
  getTenantState,
  getBoostrapPaymentProcessingFee,
);

export const getTenantBootstrapFeatureFlags = createSelector(
  getTenantState,
  getBoostrapFeatureFlags,
);

export const getTenantBootstrapMerchandisePointPercentage = createSelector(
  getTenantState,
  (data) => {
    if (
      data.minPointsPercentage?.merchandise &&
      data.maxPointsPercentage?.merchandise
    ) {
      return {
        minPointsPercentage: data.minPointsPercentage.merchandise,
        maxPointsPercentage: data.maxPointsPercentage.merchandise,
      };
    }
    return null;
  },
);

export const getPageLoadingState = createSelector(
  getTenantState,
  getBootstrapPageLoadingState,
);
